import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../api/offlineClient';
import useAuthStore from '../store/authStore';

const ROLES_ADMIN = ['admin', 'jefe', 'administrativo'];

// Endesa identifica cada instalación por su dirección (calle del centro/subestación).
// Los demás clientes traen la calle real en "dirección" pero el nombre que identifica
// la instalación (p. ej. el cliente final) viene en la columna "usuario" del Excel,
// guardada en usuario_responsable.
function instNombre(inst) {
  const esEndesa = (inst.cliente || '').toUpperCase().includes('ENDESA');
  if (esEndesa) return inst.direccion || inst.descripcion || '';
  return inst.usuario_responsable || inst.direccion || inst.descripcion || '';
}
const LBL_S = { fontSize: 10, color: 'var(--text-dim)', fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', display: 'block', marginBottom: 3 };
const INP_S = { background: '#070910', border: '1.5px solid var(--border)', borderRadius: 6, color: 'var(--text)', padding: '7px 10px', width: '100%', fontSize: 12, fontFamily: 'inherit', boxSizing: 'border-box' };

function NuevaInstalacionModal({ onClose, onCreated }) {
  const [form, setForm] = useState({
    numero_instalacion: '', referencia_interna: '', cliente: '', direccion: '',
    poblacion: '', provincia: '', familia: '', estado: 'abierto', descripcion: '',
    usuario_responsable: '', observaciones: '', revisado_por: '', medio_entrada: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState(null);

  function fld(k) { return { value: form[k], onChange: e => setForm(p => ({ ...p, [k]: e.target.value })) }; }

  async function handleSave() {
    if (!form.numero_instalacion.trim()) { setError('El número de instalación es obligatorio'); return; }
    setSaving(true);
    setError(null);
    try {
      const data = await api.post('/api/installations/create', form);
      onCreated(data.data);
    } catch (e) {
      setError(e.message || 'Error al crear la instalación');
    }
    setSaving(false);
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.8)', zIndex: 9000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 16, overflowY: 'auto' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#10131e', border: '1px solid #1c2035', borderRadius: 14, padding: 24, maxWidth: 640, width: '100%', marginTop: 20, marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: 'var(--amber)' }}>Nueva instalación</div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-dim)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={LBL_S}>Nº instalación *</label>
            <input type="text" {...fld('numero_instalacion')} style={INP_S} />
          </div>
          <div>
            <label style={LBL_S}>Referencia interna</label>
            <input type="text" {...fld('referencia_interna')} style={INP_S} />
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={LBL_S}>Cliente</label>
          <input type="text" {...fld('cliente')} style={INP_S} />
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={LBL_S}>Dirección</label>
          <input type="text" {...fld('direccion')} style={INP_S} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={LBL_S}>Población</label>
            <input type="text" {...fld('poblacion')} style={INP_S} />
          </div>
          <div>
            <label style={LBL_S}>Provincia</label>
            <input type="text" value={form.provincia}
              onChange={e => setForm(p => ({ ...p, provincia: e.target.value }))}
              style={INP_S} />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={LBL_S}>Familia</label>
            <input type="text" {...fld('familia')} style={INP_S} placeholder="Avería, Mantenimiento, Instalación…" />
          </div>
          <div>
            <label style={LBL_S}>Estado</label>
            <select {...fld('estado')} style={INP_S}>
              <option value="abierto">Abierto</option>
              <option value="pendiente">Pendiente</option>
              <option value="cerrado">Cerrado</option>
              <option value="baja">Baja</option>
            </select>
          </div>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={LBL_S}>Descripción</label>
          <textarea rows={3} {...fld('descripcion')} style={{ ...INP_S, resize: 'vertical' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div>
            <label style={LBL_S}>Responsable</label>
            <input type="text" {...fld('usuario_responsable')} style={INP_S} />
          </div>
          <div>
            <label style={LBL_S}>Revisado por</label>
            <input type="text" {...fld('revisado_por')} style={INP_S} />
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={LBL_S}>Observaciones</label>
          <textarea rows={2} {...fld('observaciones')} style={{ ...INP_S, resize: 'vertical' }} />
        </div>

        {error && (
          <div style={{ marginBottom: 14, padding: '8px 12px', background: 'rgba(248,113,113,.1)', border: '1px solid rgba(248,113,113,.3)', borderRadius: 7, fontSize: 12, color: '#f87171' }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={onClose} style={{ flex: 1, padding: '10px', background: 'var(--surface2)', color: 'var(--text-dim)', border: '1px solid var(--border)', borderRadius: 7, cursor: 'pointer', fontWeight: 700, fontSize: 12 }}>
            Cancelar
          </button>
          <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '10px', background: 'var(--amber)', color: '#000', border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 800, fontSize: 13, opacity: saving ? 0.6 : 1 }}>
            {saving ? 'Guardando…' : '+ Crear instalación'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Badge({ estado }) {
  if (estado === 'abierto')   return <span className="sg-badge sg-badge-open">abierto</span>;
  if (estado === 'cerrado')   return <span className="sg-badge sg-badge-closed">cerrado</span>;
  if (estado === 'pendiente') return <span className="sg-badge sg-badge-pending">pendiente</span>;
  if (estado === 'baja')      return <span style={{ fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: 'rgba(248,113,113,.1)', color: '#f87171', border: '1px solid rgba(248,113,113,.3)' }}>baja</span>;
  return <span style={{ color: 'var(--text-dim)' }}>{estado || '—'}</span>;
}

function DetailPanel({ inst, onClose }) {
  if (!inst) return null;

  const fields = [
    ['Nº Instalación',  inst.numero_instalacion],
    ['Ref. Interna',    inst.referencia_interna],
    ['Cliente',         inst.cliente],
    ['Dirección',       inst.direccion],
    ['Población',       inst.poblacion],
    ['Provincia',       inst.provincia],
    ['Familia',         inst.familia],
    ['Estado',          inst.estado, 'badge'],
    ['Descripción',     inst.descripcion],
    ['Responsable',     inst.usuario_responsable],
    ['Revisado por',    inst.revisado_por],
    ['Observaciones',   inst.observaciones],
    ['Fecha entrada',   inst.fecha_entrada   ? new Date(inst.fecha_entrada).toLocaleDateString('es-ES')   : null],
    ['Medio entrada',   inst.medio_entrada],
    ['Última revisión', inst.fecha_ultima_revision ? new Date(inst.fecha_ultima_revision).toLocaleDateString('es-ES') : null],
  ].filter(([, v]) => v);

  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', justifyContent: 'flex-end' }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--surface)', borderLeft: '1px solid var(--border)',
          width: '100%', maxWidth: 420, height: '100%', overflowY: 'auto',
          padding: '20px 20px 40px', boxShadow: '-4px 0 32px rgba(0,0,0,.5)',
          display: 'flex', flexDirection: 'column', gap: 0,
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div>
            <div style={{ fontFamily: 'monospace', fontWeight: 900, color: 'var(--amber)', fontSize: 18 }}>
              {inst.numero_instalacion}
            </div>
            {inst.referencia_interna && (
              <div style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 2 }}>
                Ref: {inst.referencia_interna}
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: 'var(--text-dim)', cursor: 'pointer', fontSize: 20, lineHeight: 1, padding: 4 }}
          >✕</button>
        </div>

        {/* Badge estado */}
        <div style={{ marginBottom: 16 }}>
          <Badge estado={inst.estado} />
          {inst.familia && (
            <span style={{ marginLeft: 8, display: 'inline-block', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: 'rgba(59,130,246,.1)', color: '#60a5fa', border: '1px solid rgba(59,130,246,.2)' }}>
              {inst.familia}
            </span>
          )}
        </div>

        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 16, display: 'grid', gap: 14 }}>
          {fields.filter(([l]) => !['Nº Instalación','Ref. Interna','Estado','Familia'].includes(l)).map(([label, val, type]) => (
            <div key={label}>
              <div style={{ fontSize: 10, color: 'var(--text-dim)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 3 }}>
                {label}
              </div>
              <div style={{ fontSize: 13, color: 'var(--text)', wordBreak: 'break-word', lineHeight: 1.5 }}>
                {type === 'badge' ? <Badge estado={val} /> : (val || '—')}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Instalaciones() {
  const user = useAuthStore(s => s.user);
  const canCreate = ROLES_ADMIN.includes(user?.rol);
  const [rows, setRows]             = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, pages: 1 });
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState(null);
  const [search, setSearch]         = useState('');
  const [applied, setApplied]       = useState('');
  const [page, setPage]             = useState(1);
  const [selected, setSelected]     = useState(null);
  const [showNew, setShowNew]       = useState(false);
  const debounce = useRef(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams({ page, limit: 25 });
      if (applied) params.set('search', applied);
      const data = await api.get(`/api/installations/list?${params}`);
      setRows(data.data);
      setPagination(data.pagination);
    } catch (e) {
      setError(e.message || 'Error al cargar instalaciones');
    }
    setLoading(false);
  }, [page, applied]);

  useEffect(() => { fetchData(); }, [fetchData]);

  function handleSearch(e) {
    const val = e.target.value;
    setSearch(val);
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => { setApplied(val); setPage(1); }, 400);
  }

  function clearSearch() {
    setSearch('');
    setApplied('');
    setPage(1);
  }

  return (
    <div style={{ padding: 20, maxWidth: 1400, margin: '0 auto', width: '100%' }}>
      <DetailPanel inst={selected} onClose={() => setSelected(null)} />
      {showNew && (
        <NuevaInstalacionModal
          onClose={() => setShowNew(false)}
          onCreated={() => { setShowNew(false); setPage(1); fetchData(); }}
        />
      )}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 900, color: 'var(--text)' }}>Instalaciones 2026</h1>
          <p style={{ fontSize: 12, color: 'var(--text-dim)', marginTop: 3 }}>
            {loading ? 'Cargando...' : `${pagination.total.toLocaleString()} registros`}
          </p>
        </div>
        {canCreate && (
          <button className="sg-btn-primary" onClick={() => setShowNew(true)} style={{ padding: '8px 16px', fontSize: 12, fontWeight: 800 }}>
            + Añadir instalación
          </button>
        )}
      </div>

      {/* Error */}
      {error && (
        <div style={{ marginBottom: 14, padding: '10px 14px', background: 'rgba(248,113,113,.1)', border: '1px solid rgba(248,113,113,.3)', borderRadius: 7, fontSize: 13, color: '#f87171', display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontWeight: 700 }}>⚠ Error:</span> {error}
          <button onClick={fetchData} style={{ marginLeft: 'auto', background: 'none', border: '1px solid rgba(248,113,113,.5)', color: '#f87171', borderRadius: 5, padding: '3px 10px', cursor: 'pointer', fontSize: 12 }}>Reintentar</button>
        </div>
      )}

      {/* Búsqueda */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input
          className="sg-input"
          value={search}
          onChange={handleSearch}
          placeholder="Buscar por número, dirección, familia, estado..."
          style={{ flex: 1 }}
        />
        {search && (
          <button className="sg-btn-sec" onClick={clearSearch} style={{ padding: '0 14px', flexShrink: 0 }}>
            ✕
          </button>
        )}
      </div>

      {/* Tabla */}
      <div className="sg-card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: 'var(--surface2)', borderBottom: '1px solid var(--border)' }}>
                {[
                  { label: 'Nº Instalación', w: 130 },
                  { label: 'Nombre',         w: 220 },
                  { label: 'Familia',        w: 120 },
                  { label: 'Estado',         w: 90  },
                  { label: 'Descripción',    w: 'auto' },
                ].map(h => (
                  <th key={h.label} style={{
                    padding: '10px 12px', textAlign: 'left',
                    color: 'var(--text-dim)', fontWeight: 700,
                    fontSize: 10, textTransform: 'uppercase',
                    letterSpacing: '.06em', whiteSpace: 'nowrap',
                    width: h.w !== 'auto' ? h.w : undefined,
                    minWidth: h.w !== 'auto' ? h.w : undefined,
                  }}>{h.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} style={{ padding: 48, textAlign: 'center', color: 'var(--text-dim)' }}>
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
                      <div style={{ width: 16, height: 16, border: '2px solid var(--border)', borderTopColor: 'var(--amber)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
                      Cargando...
                    </div>
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ padding: 48, textAlign: 'center', color: 'var(--text-dim)' }}>
                    Sin resultados{applied ? ` para "${applied}"` : ''}
                  </td>
                </tr>
              ) : rows.map(r => (
                <tr
                  key={r.id}
                  onClick={() => setSelected(selected?.id === r.id ? null : r)}
                  style={{
                    borderBottom: '1px solid var(--border)',
                    cursor: 'pointer',
                    background: selected?.id === r.id ? 'rgba(251,191,36,.06)' : '',
                  }}
                  onMouseEnter={e => { if (selected?.id !== r.id) e.currentTarget.style.background = 'rgba(255,255,255,.025)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = selected?.id === r.id ? 'rgba(251,191,36,.06)' : ''; }}
                >
                  <td style={{ padding: '9px 12px', fontFamily: 'monospace', fontSize: 11, color: 'var(--amber)', fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {r.numero_instalacion}
                  </td>
                  <td style={{ padding: '9px 12px', color: 'var(--text)', maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {instNombre(r) || '—'}
                  </td>
                  <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
                    {r.familia
                      ? <span style={{ display: 'inline-block', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 4, background: 'rgba(59,130,246,.1)', color: '#60a5fa', border: '1px solid rgba(59,130,246,.2)' }}>{r.familia}</span>
                      : <span style={{ color: 'var(--text-dim)' }}>—</span>}
                  </td>
                  <td style={{ padding: '9px 12px' }}>
                    <Badge estado={r.estado} />
                  </td>
                  <td style={{ padding: '9px 12px', color: 'var(--text-dim)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {r.descripcion || '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Paginación */}
        {pagination.pages > 1 && (
          <div style={{
            padding: '12px 16px', borderTop: '1px solid var(--border)',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            fontSize: 12, color: 'var(--text-dim)', flexWrap: 'wrap', gap: 8,
          }}>
            <span>
              Página <strong style={{ color: 'var(--text)' }}>{pagination.page}</strong> de {pagination.pages}
              {' '}· {pagination.total.toLocaleString()} resultados
            </span>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <button className="sg-btn-sec" style={{ padding: '5px 12px' }}
                disabled={page <= 1} onClick={() => setPage(p => p - 1)}>
                ← Anterior
              </button>
              {Array.from({ length: Math.min(5, pagination.pages) }, (_, i) => {
                const p = Math.max(1, Math.min(pagination.pages - 4, page - 2)) + i;
                return (
                  <button key={p} onClick={() => setPage(p)} style={{
                    padding: '5px 10px', borderRadius: 6, border: 'none', cursor: 'pointer',
                    background: p === page ? 'var(--amber)' : '#15192a',
                    color: p === page ? '#000' : 'var(--text-dim)',
                    fontWeight: p === page ? 800 : 600, fontSize: 12,
                  }}>{p}</button>
                );
              })}
              <button className="sg-btn-sec" style={{ padding: '5px 12px' }}
                disabled={page >= pagination.pages} onClick={() => setPage(p => p + 1)}>
                Siguiente →
              </button>
            </div>
          </div>
        )}
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
